import { useSyncExternalStore } from 'react'
import type { DeliveryAddress } from './api'

/**
 * Адрес, выбранный на странице адреса. Страница и оформление — разные
 * экраны, а выбор должен пережить переход обратно; в браузер его не пишем:
 * сохраняет адрес сервер, когда уходит заказ с доставкой.
 */
let chosen: DeliveryAddress | null = null
const listeners = new Set<() => void>()

export function chooseAddress(address: DeliveryAddress | null): void {
  chosen = address
  for (const listener of listeners) listener()
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Что выбрано сейчас — без подписки, для кода вне React. */
export function chosenAddress(): DeliveryAddress | null {
  return chosen
}

export function useChosenAddress(): DeliveryAddress | null {
  return useSyncExternalStore(subscribe, chosenAddress)
}
